import {
  mobileSearchPlaceholderText,
  searchPlaceholderText,
} from 'sharedComponents/Filters/constants';

export const getSearchPlaceholderText = (isMobile) =>
  isMobile ? mobileSearchPlaceholderText : searchPlaceholderText;
